import React, { PureComponent } from 'react';
import { Menu } from 'semantic-ui-react';
import './Sidebar.css';

export default class SideBar extends PureComponent {
  onTabClick = (_, { name }) => {
    const { setAppState, activeTab } = this.props;
    if (activeTab === name) return;

    setAppState({ activeTab: name });
  };

  render() {
    const { activeTab, tabs } = this.props;

    return (
      <div className="sideBar">
        {tabs.filter(tab => !tab.hide).map(tab => (
          <Menu.Item
            as="a"
            key={tab.name}
            name={tab.name}
            active={activeTab === tab.name}
            onClick={this.onTabClick}
            className={`sidebarTab${tab.disabled ? ' disabled' : ''}`}
            disabled={tab.disabled}
          >
            <div className="sidebarLabel">{tab.label}</div>
          </Menu.Item>
        ))}
      </div>
    );
  }
}
/*{tab.iconUrl && (
  <div className="sidebarImage">
    <img src={tab.iconUrl} alt={tab.name} />
  </div>
)}*/



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js